import {
  FormControl,
  FormsModule,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SECTIONS } from '@data/sections';
import { FormComponent } from '@classes/form';
import { AlertComponent } from '@components/alert/alert.component';

@Component({
  selector: 'app-newsletter',
  imports: [FormsModule, RouterLink, ReactiveFormsModule, AlertComponent],
  templateUrl: './newsletter.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './newsletter.scss',
})
export class Newsletter extends FormComponent {
  protected readonly topics = SECTIONS;

  override form = this.formBuilder.group({
    name: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    legals: new FormControl(false, [Validators.requiredTrue]),
  });

  protected receiveAll = true;
  protected selectedTopics = new Set<string>();
  protected submitted = false;

  ngOnInit(): void {
    this.endpoint = 'api/newsletter';
    this.method = 'post';
  }

  onReceiveAllChange(checked: boolean): void {
    this.receiveAll = checked;

    if (checked) {
      this.selectedTopics.clear();
    }
  }

  toggleTopic(slug: string, checked: boolean): void {
    if (checked) {
      this.selectedTopics.add(slug);
    } else {
      this.selectedTopics.delete(slug);
    }
  }

  override getParams(): void {
    const params = this.form.value;
    const formValue: any = {};

    formValue.name = params.name;
    formValue.lastname = params.lastname;
    formValue.email = params.email;
    formValue.legals = params.legals;

    if (this.receiveAll) {
      formValue.topics = this.topics.map((topic) => topic.name);
    } else {
      formValue.topics = Array.from(this.selectedTopics);
    }

    return formValue;
  }

  override isValid(): boolean {
    this.form.markAllAsTouched();

    const valid =
      this.form.valid && (this.receiveAll || this.selectedTopics.size > 0);

    if (!valid) {
      this.handleAlert('Por favor, complete todos los campos.', 'danger');
    }

    return valid;
  }

  override success(_response: any): void {
    this.submitted = true;
    this.receiveAll = true;
    this.form.reset();
    this.selectedTopics.clear();
    this.stopLoading();
  }
}
